import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            实时快讯
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">24小时不间断更新的最新瓜条动态</p>
        </div>

        <div className="max-w-[720px] mx-auto">
          {updateItems.map((item, idx) => (
            <div key={idx} className="relative flex gap-4 pb-6 last:pb-0">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 rounded-full bg-primary-500 flex-shrink-0 mt-1.5"></div>
                {idx < updateItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 mt-1.5"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-2">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                  {item.badge && (
                    <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
                      item.badge === '最新' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                    }`}>{item.badge}</span>
                  )}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}